import { useEffect, useState } from 'react'
import { healthApi } from './api'

/**
 * حالة الاتصال. navigator.onLine يكتشف فقدان الشبكة لا فقدان الخادم،
 * لذا نتحقّق من /health دورياً — في المرحلة ٢ سيغذّي هذا شريط المزامنة.
 */
export function useOnlineStatus(pollMs = 20_000) {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine)
  const [serverReachable, setServerReachable] = useState<boolean | null>(null)

  useEffect(() => {
    const onOnline = () => setIsOnline(true)
    const onOffline = () => {
      setIsOnline(false)
      setServerReachable(false)
    }
    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)
    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [])

  useEffect(() => {
    let cancelled = false
    const controller = new AbortController()

    async function ping() {
      if (!navigator.onLine) {
        if (!cancelled) setServerReachable(false)
        return
      }
      try {
        const res = await healthApi.check(controller.signal)
        if (!cancelled) setServerReachable(res.status === 'ok')
      } catch {
        if (!cancelled) setServerReachable(false)
      }
    }

    void ping()
    const id = setInterval(() => void ping(), pollMs)
    return () => {
      cancelled = true
      controller.abort()
      clearInterval(id)
    }
  }, [pollMs])

  return { isOnline, serverReachable, isConnected: isOnline && serverReachable !== false }
}
